import React from "react";
import './Transparency.css'

const Transparency = () => (
  <section className="transparency">
    <h2>Transparencia Garantizada</h2>
    <p>🔒 Los resultados se publicarán en nuestras redes sociales y página oficial.</p>
    <p>🎉 Sorteo oficial realizado de manera transparente usando una plataforma verificada.</p>
  </section>
);

export default Transparency;
